import React from "react";
import { useDispatch } from "react-redux";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useSelector } from "react-redux";
import { logout } from "../redux/actions/session-action-types";
import { auth } from "../firebase";
import { push } from "connected-react-router";

function Header() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.user);

  const handleLogout = (e) => {
    e.preventDefault();
    /** Google SignOut, Call logout saga even if not logged out by google, we have to signout from our app anyway. */
    console.log("Logout >>>");
    auth
      .signOut()
      .then(() => dispatch(logout()))
      .catch(() => dispatch(logout()));
  };

  return (
    <div className="main-bggrey">
      <header className="bg-white header py-2">
        <div className="container">
          <nav className="w-100  d-flex justify-content-between flex-wrap py-1 align-items-center">
            <div className="bid-logo">
              {/* <Link href="/user-dashboard"> */}
              <a href="#" onClick={(e)=>{e.preventDefault(); dispatch(push('/'))}} className="navbar-brand">
                <img src="/assets/images/logo.svg" alt="logo" />
              </a>
              {/* </Link> */}
            </div>
            <div className="bid-ac">
              <div className="dropdown profbtn">
                <UncontrolledDropdown setActiveFromChild>
                  <span>
                    <img src="/assets/images/pc.png" alt="pc" />
                  </span>
                  <DropdownToggle tag="a">
                    <button
                      className="btn box-shadow-none dropdown-toggle pr-0"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {user.displayName}
                    </button>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu">
                    <DropdownItem className="dropdown-item">
                      <a onClick={(e)=>{e.preventDefault(); handleLogout(e)}} className="dropdown-item" href="#/">
                       Logout
                      </a>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
}

export default Header;
